import API from "./axios";

/**
 * Stitching Operation master — the operations themselves (name, code,
 * description, status), plus the Excel export / sample file / import. The job
 * work rate and the order are set per barcode: see barcodeOperationApi.
 */
const stitchingOperationApi = {
  paged:   (params = {}) => API.get("/stitching-operations/paged", { params }),
  /** Active operations for pick lists, by name. */
  active:  ()            => API.get("/stitching-operations/active"),
  getById: (id)          => API.get(`/stitching-operations/${id}`),
  create:  (body)        => API.post("/stitching-operations", body),
  update:  (id, body)    => API.put(`/stitching-operations/${id}`, body),
  toggle:  (id)          => API.patch(`/stitching-operations/${id}/toggle-status`),
  delete:  (id)          => API.delete(`/stitching-operations/${id}`),

  /** Register as .xlsx — same q / isActive filter as the screen. */
  exportExcel:    (params = {}) => API.get("/stitching-operations/export/excel", { params, responseType: "blob" }),
  /** Blank import sheet with an Instructions tab. */
  importTemplate: ()            => API.get("/stitching-operations/import/template", { responseType: "blob" }),
  /**
   * Upload an .xlsx. All-or-nothing: the result lists row errors, and when
   * there are any nothing was saved.
   */
  importExcel: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    // Content-Type left to the browser so it adds the multipart boundary;
    // the axios instance defaults to JSON.
    return API.post("/stitching-operations/import", fd, { headers: { "Content-Type": undefined } });
  },
};

export default stitchingOperationApi;
